import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

export function useBlockPopAction() {
  const history = useHistory()

  useEffect(() => {
    const unblock = history.block((_, action) => {
      if (action === 'POP') return false
      return undefined
    })

    return () => unblock()
  }, [history])
}
